import type { IVisaSearchSchema } from "@/feature/visa/search/types/visa.types";

export function formatVisaTravelerLabel(searchData: IVisaSearchSchema | null) {
  const travelers = searchData?.travelers ?? 1;
  return `${travelers} traveler${travelers === 1 ? "" : "s"}`;
}

export function formatVisaCountryMeta(searchData: IVisaSearchSchema | null) {
  if (!searchData?.country?.iso) {
    return "All countries";
  }

  return searchData.country.iso3
    ? `${searchData.country.iso} · ${searchData.country.iso3}`
    : searchData.country.iso;
}
